export const TRANSACTIONS_CLONE = `
    mutation M($transaction_id: Id!) {
        transaction_clone(input: {
            transaction_id: $transaction_id
        }) {
            id
        }
    }
`;
